import { useSyncExternalStore } from 'react'

export const REFERRER_CHANGE_EVENT = 'app-referrer-change'

export const notifyReferrerChange = () => {
  window.dispatchEvent(new Event(REFERRER_CHANGE_EVENT))
}

const subscribe = (callback) => {
  window.addEventListener(REFERRER_CHANGE_EVENT, callback)
  window.addEventListener('storage', callback)
  return () => {
    window.removeEventListener(REFERRER_CHANGE_EVENT, callback)
    window.removeEventListener('storage', callback)
  }
}

const getSnapshot = () => {
  const corusCodeName = window.__RUNTIME_CONFIG__?.VITE_CORUS_CODENAME || ''
  const appCode = sessionStorage.getItem('appCode')
  const referrer = corusCodeName || sessionStorage.getItem('referrer')
  return `${appCode || ''}|${referrer || ''}`
}

// Re-renders the calling component whenever appCode/referrer change in sessionStorage,
// even within the same tab (native 'storage' events don't fire for same-window writes).
const useReferrerAppCode = () => {
  const snapshot = useSyncExternalStore(subscribe, getSnapshot)
  const [appCode, referrer] = snapshot.split('|')
  return { appCode: appCode || null, referrer: referrer || null }
}

export default useReferrerAppCode
